import React from "react";
import { motion } from "framer-motion";
import { comparisonData } from "../Data";

const fade = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { duration: 0.6, ease: "easeOut" },
  },
};

const container = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.08,
      delayChildren: 0.2,
    },
  },
};

const rowAnim = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { duration: 0.3 },
  },
};

const ApplicationTable = () => {
  return (
    <section className="compare-section">
      <div className="container">

        {/* HEADINGS */}
        <motion.h3
          className="section-subheading"
          variants={fade}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          Compare Our Tile Adhesive Range
        </motion.h3>

        <motion.h2
          className="section-heading"
          variants={fade}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          Find the right adhesive based on your application, surface, and project needs.
        </motion.h2>

        {/* TABLE WRAPPER */}
        <motion.div
          className="table-wrapper"
          variants={fade}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          <table className="compare-table">

            {/* HEADER (static, no animation needed) */}
            <thead>
              <tr>
                <th><h4 className="feature-text">Feature</h4></th>
                <th><h4 className="card-heading">Grip Bond</h4></th>
                <th><h4 className="card-heading">Pro Bond</h4></th>
                <th><h4 className="card-heading">Ultra Bond</h4></th>
              </tr>
            </thead>

            {/* BODY */}
            <motion.tbody
              variants={container}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
            >
              {comparisonData.map((row, index) => (
                <motion.tr key={index} variants={rowAnim}>
                  <td className="feature-col">{row.feature}</td>
                  <td className="section-text">{row.grip}</td>
                  <td className="section-text">{row.pro}</td>
                  <td className="section-text">{row.ultra}</td>
                </motion.tr>
              ))}
            </motion.tbody>

          </table>
        </motion.div>

      </div>
    </section>
  );
};

export default ApplicationTable;